<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="100" inline>
        <FormItem label="请求时间">
          <DatePicker
            type="daterange"
            split-panels
            placeholder="选择时间区间"
            format="yyyy-MM-dd"
            @on-change="getDateTime"
          ></DatePicker>
        </FormItem>
        <FormItem label="请求者">
          <Input placeholder="请输入" v-model="table.search.Requester"></Input>
        </FormItem>
        <FormItem label="日志类型">
          <Input placeholder="请输入" v-model="table.search.LogType"></Input>
        </FormItem>
        <FormItem label="接口名">
          <Input placeholder="请输入" v-model="table.search.InterfaceLogTitle"></Input>
        </FormItem>
      </Form>
      <Button class="mr-3" type="success" @click="search">查询</Button>

    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
    ></DataTable>

    <!--详情-->
    <Modal
      v-model="detailModal"
      title="日志详情"
      :footer-hide="true"
      
      :closable="false"
      width="60%"
    >
      <logDetail
        v-if="detailModal"
        @close="detailModal = false"
        :currentData="currentData"
      ></logDetail>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import logDetail from "../Interfacelog/detail.vue";

export default {
  components: { DataTable, logDetail },
  data: function () {
    return {
      dateTime: [],
      EmailSendFlagSelect: [],
      currentData: {},
      detailModal: false,
      table: {
        columns: [
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "请求者", key: "requester" },
          { title: "日志类型", key: "logType" },
          { title: "接口名", key: "interfaceLogTitle" },
          { title: "客户端", key: "interfaceLogClient" },
          { title: "请求时间", key: "logDate" },
          {
            title: "操作",
            width: "80px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
              ]);
            },
          },
        ],
        apiUrl: "log/getInterfacelogList",
        search: {
          LogType: null,
          Requester: "",
          InterfaceLogTitle: "",
          LogDateStart: null,
          LogDateEnd: null,
        },
      },
    };
  },

  created: function () {},
  activated(){
    this.search()
  },
  methods: {
    getDateTime(dateTime) {
      if (dateTime) {
        this.table.search.LogDateStart = dateTime[0];
        this.table.search.LogDateEnd = dateTime[1];
      }
    },
    search: function () {
      this.$refs.dataTable.initload();
    },

    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = data;
    },
  },
};
</script>
<style scoped>
</style>